import { AutoCompleteComponent } from '@app/reports/report-settings/auto-complete/auto-complete.component';
import { BarGraphHorizontalComponent } from '@app/reports/graphs/bar-graph-horizontal/bar-graph-horizontal.component';
import { BarGraphStackedComponent } from '@app/reports/graphs/bar-graph-stacked/bar-graph-stacked.component';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenLineGraphComponent } from '@app/reports/graphs/gen-line-graph/gen-line-graph.component';
import { LineGraphComponent } from '@app/reports/graphs/line-graph/line-graph.component';
import { MarketSegmentsComponent } from '@app/reports/market-segments/market-segments.component';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MaterialDemandReportService } from '@app/reports/material-demand/material-demand-report.service';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MaterialDemandComponent } from '@app/reports/material-demand/material-demand.component';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { NgModule } from '@angular/core';
import { NotificationsModule } from '@app/notifications/notifications.module';
import { PieChartComponent } from '@app/reports/graphs/pie-chart/pie-chart.component';
import { PortalModule } from '@angular/cdk/portal';
import { ReportSwitcherComponent } from '@app/reports/report-switcher/report-switcher.component';
import { SalesQuantityComponent } from '@app/reports/sales-quantity/sales-quantity.component';
import { SharedModule } from '@app/shared/shared.module';
import { ShippedOrdersComponent } from '@app/reports/shipped-order/shipped-orders.component';
import { TruckDemandComponent } from '@app/reports/truck-demand/truck-demand.component';
import { WidgetContainerComponent } from '@app/reports/widget-container/widget-container.component';
import { WidgetContainerDialogComponent } from '@app/reports/widget-container/widget-container-dialog.component';

@NgModule({
  declarations: [
    AutoCompleteComponent,
    BarGraphHorizontalComponent,
    BarGraphStackedComponent,
    GenLineGraphComponent,
    LineGraphComponent,
    MarketSegmentsComponent,
    MaterialDemandComponent,
    PieChartComponent,
    ReportSwitcherComponent,
    SalesQuantityComponent,
    ShippedOrdersComponent,
    TruckDemandComponent,
    WidgetContainerComponent,
    WidgetContainerDialogComponent
  ],
  imports: [
    CommonModule,
    DragDropModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatOptionModule,
    MatRadioModule,
    MatToolbarModule,
    MatTooltipModule,
    NotificationsModule,
    PortalModule,
    ReactiveFormsModule,
    SharedModule
  ],
  exports: [WidgetContainerComponent, ReportSwitcherComponent, AutoCompleteComponent],
  providers: [MaterialDemandReportService]
})
export class ReportsModule {}
